"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.zuoraToSearchParams = void 0;
/**
 * Transforms the ZuoraParams to a URLSearchParams object
 * @param data the ZuoraParams object
 * @param additionalParams Any additional parameters to be added to the URLSearchParams
 * @returns URLSearchParams object with the tracking parameters
 */
function zuoraToSearchParams(data, additionalParams) {
    var searchParams = new URLSearchParams();
    Object.keys(data).forEach(function (key) {
        searchParams.append(key, data[key]);
    });
    if (additionalParams) {
        Object.keys(additionalParams).forEach(function (key) {
            if (typeof additionalParams[key] !== 'undefined')
                searchParams.append(key, additionalParams[key]);
        });
    }
    return searchParams;
}
exports.zuoraToSearchParams = zuoraToSearchParams;
//# sourceMappingURL=zuora-to-search-params.js.map